import { pieChart } from "#root/dashboard/charts/components/pie_chart";
import { $ } from "#root/dashboard/l10n";
import { hidePopup, showPopup } from "../bottom-popup";
export function pieChartBox(chart, chartCard) {
  const chartHolder = document.createElement("div");
  chartHolder.classList.add("pie-chart-list");
  if (chart.sets === null || chart.sets === undefined) chart.sets = [];

  if (chart.sets.length < 1) {
    const chartHolder = document.createElement("div");
    chartHolder.innerText = $("not_enough_data");
    return chartHolder;
  }

  const pieChartsContainer = document.createElement("div");
  pieChartsContainer.classList.add("pie-charts-container");
  chartHolder.appendChild(pieChartsContainer);
  const pieChartContainer = document.createElement("div");
  pieChartContainer.classList.add("pie-chart");
  pieChartsContainer.appendChild(pieChartContainer);
  const chartContent = document.createElement("div");
  chartContent.classList.add("chart-content");
  pieChartContainer.appendChild(chartContent);
  const chartValue = document.createElement("div");
  chartValue.classList.add("chart-center-value");
  chartContent.appendChild(chartValue);
  const canvas = document.createElement("canvas");
  canvas.classList.add("pie-canvas");
  chartContent.appendChild(canvas);
  chartCard.dataset.type = "pie";
  let eventRegistry = [];
  requestAnimationFrame(async () => {
    const chartCtrl = await pieChart(canvas, chart, {
      chartContent,
      onHover: (hovered, oldHovered, direct) => {
        if (hovered) {
          chartValue.textContent = hovered.value + "%";
          const idx = chart.sets.indexOf(hovered);
          chartCard.querySelector(`.chart-legend`).classList.add("active");
          [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => item.classList.toggle("active", idx == item.dataset.idx));

          if (direct) {
            showPopup().textContent = hovered.label;
          }
        } else {
          if (oldHovered) {
            const idx = chart.sets.indexOf(oldHovered);
            chartCard.querySelector(`.chart-legend`).classList.remove("active");
            [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => item.classList.remove("active"));
          }

          hidePopup();
        }

        chartCard.classList.toggle("chart-active", !!hovered); // chartCard.querySelector(".chart-title").textContent = hovered ? hovered.label : chart.title;

        chartCard.style.setProperty("--chart-hover-color", hovered ? hovered.color : "");
      }
    });
    eventRegistry.push(() => {
      chartCtrl.destroy();
    });
    [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => {
      let setActive = e => {
        chartCtrl.setActive(chart.sets[item.dataset.idx]);
      };

      let setBlur = () => {
        chartCtrl.blur();
      };

      item.addEventListener("mouseenter", setActive, {
        passive: true
      });
      item.addEventListener("mouseleave", setBlur, {
        passive: true
      });
      eventRegistry.push(() => {
        item.removeEventListener("mouseenter", setActive, {
          passive: true
        });
        item.removeEventListener("mouseleave", setBlur, {
          passive: true
        });
      });
    });
  });

  chartHolder.destroy = () => {
    eventRegistry.forEach(fn => fn());
  };

  return chartHolder;
}